export enum CONTRACT_TYPES {
  Festangestellter = 'Festangestellter',
  Experthouse = 'Experthouse',
  Zukauf = 'Zukauf',
  Student = 'Student',
  Support = 'Support',
  Fachberatung = 'Fachberatung',
  WorkingContract = 'WorkingContract',
  Internship = 'Internship',
}
